import "../../index.css";
import AppModal from "../common/AppModal";
import AssignShiftContent from "./assign-shift-content";

interface IProps {
    title?: string;
    open: boolean;
    handleClose: any;
    listMembers?: any;
    editMode?: boolean;
    editMember?: any;
}

export const AssignShiftModel = ({
    title,
    open,
    handleClose,
    editMode,
    editMember,
    listMembers,
}: IProps) => {
    return (
        <>
            <AppModal
                title={title || "Assign Shift"}
                open={open}
                handleClose={handleClose}
                fullScreen={false}
                maxWidth={"md"}
            >
                <AssignShiftContent
                    listMembers={listMembers}
                    editMode={editMode}
                    editMember={editMember}
                />
            </AppModal>
        </>
    );
};
